// Packages Import
import React, { Fragment , useEffect, useState } from "react"
import { Box} from "@mui/material"
import { useDispatch, useSelector } from "react-redux";

// Project Component
import useHttp from "../../../Hooks/use-http"
import FullScreenLoadingIndicator from "../../UI/FullScreenLoadingIndicator"
import { findPartAction } from "../../../store/common/findPart-slice"
import { cmActions } from "../../../store/CM/CM-slice"
import { APIURL } from "../../Util/Util"
import ErrorBox from "../../Util/ErrorBox"
import CMHeader from "./CMHeader";
import CMQuantityTable from "./Tables/CMQuantityTable";
import CMForecastTable from "./Tables/CMForecastTable";
import MacsPriceInfoTable from "./Tables/MacsPriceInfoTable";
import RRCMDemandTable from "./Tables/RRCMDemandTable";
import RRCMQuantityTable from "./Tables/RRCMQuantityTable";
import BottomNavigation from "./CMBottomBar";


const CM = () => {
	const dispatch = useDispatch();
	const accessToken = useSelector((state) => state.authenticationState.accessToken);

	const headers = { "Content-Type": "application/json", Authorization: "Bearer " + accessToken };
	// const headers = { "Content-Type": "application/json"};
	const { isLoading, sendRequest: fetchData } = useHttp()
	const [errorMsg , setErrorMsg] = useState("")
	const [errorState , setErrorState] = useState(false)
	const showFindPart = useSelector((state) => state.findPartState.showFindPart);
	const reloadPartNumber = useSelector((state) => state.cmState.reloadPartNumber);

	const updateData = (partNumber) => (data) => {
		// Temporary work around until backend pass the correct value
		const partInfo = data.PARTS_INFO || data.PART_INFO
		if(!Array.isArray(partInfo) && Object.keys(partInfo).length !== 0){
			dispatch(findPartAction.setShowFindPart(false));
			dispatch(cmActions.updateAll({ data: data}))
		}else{
			console.log("Here")
			if (!showFindPart) {
				setErrorMsg(`Part Number not available`);
				setErrorState(true);
				const subsetLoaded = JSON.parse(window.sessionStorage.getItem("subsetLoaded"));
				if (subsetLoaded) {
					dispatch(cmActions.reset());
					dispatch(cmActions.setPartNumberForSubset(partNumber));
				}
			} else {
				dispatch(findPartAction.setPartFound(false));
			}
		}
	}

	const APIError = (partNumber) => (error) => {
		console.log(`ERROR: Unable to retrieve ${partNumber} : ${error}`);
		setErrorMsg(`ERROR: ${error}`);
		setErrorState(true);

	};

	const changePart = (partNumber) => {
		fetchData({ 
			url: `${APIURL}cm/cmlist/${partNumber}/`, headers: headers
		}, updateData(partNumber) , APIError(partNumber))
	}

	useEffect(() => {
		const partNumber = window.sessionStorage.getItem("PartNumber")
		if (partNumber) {
			changePart(partNumber)
		}else{
			dispatch(findPartAction.setShowFindPart(true));
		}
		
	}, [reloadPartNumber]); // eslint-disable-line react-hooks/exhaustive-deps

	
	return (
		<React.StrictMode>
			<Fragment>
				<FullScreenLoadingIndicator loading={isLoading} />
				<Box 
					maxWidth={"85%"} 
					mx={"auto"} 
					mt={2}
				>
                    <CMHeader />
                    <CMQuantityTable />
                    <RRCMQuantityTable />
                    <MacsPriceInfoTable />
                    <CMForecastTable />
                    <RRCMDemandTable />

				</Box>
				<BottomNavigation 
					changePart={changePart}
				/>
				<ErrorBox 
					msg = {errorMsg}
					setErrorState = {setErrorState}
					ErrorState = {errorState}
				/>
			</Fragment>
		</React.StrictMode>
		
	)
}

export default CM